// extracted by mini-css-extract-plugin
export var btn = "home-module--btn--K39-2";
export var footnote = "home-module--footnote--dXxo3";
export var header = "home-module--header--yqOgg";